import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader, TranslocoLoaderData } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppTranslocoLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string, data?: TranslocoLoaderData): Observable<Translation> {
    const scopedPath = data?.scope && !lang.includes('/') ? `${data.scope}/${lang}` : lang;
    return this.http.get<Translation>(`/i18n/${scopedPath}.json`);
  }
}
